var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4166 10.5417V13.625C15.4166 16.225 12.9916 18.3333 9.99998 18.3333C7.00831 18.3333 4.58331 16.225 4.58331 13.625V10.5417C4.58331 13.1417 7.00831 15 9.99998 15C12.9916 15 15.4166 13.1417 15.4166 10.5417Z",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4166 6.37499C15.4166 7.13332 15.2083 7.83332 14.8416 8.43332C13.95 9.89999 12.1166 10.8333 9.99998 10.8333C7.88331 10.8333 6.04998 9.89999 5.15832 8.43332C4.79165 7.83332 4.58331 7.13332 4.58331 6.37499C4.58331 5.07499 5.19164 3.89999 6.16664 3.04999C7.14997 2.19166 8.49998 1.66666 9.99998 1.66666C11.5 1.66666 12.85 2.19166 13.8333 3.04166C14.8083 3.89999 15.4166 5.07499 15.4166 6.37499Z",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4166 6.37499V10.5417C15.4166 13.1417 12.9916 15 9.99998 15C7.00831 15 4.58331 13.1417 4.58331 10.5417V6.37499C4.58331 3.77499 7.00831 1.66666 9.99998 1.66666C11.5 1.66666 12.85 2.19166 13.8333 3.04166C14.8083 3.89999 15.4166 5.07499 15.4166 6.37499Z",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoin);
export default __webpack_public_path__ + "static/media/coin.abb9ef809d726206f3aa7aba7d9b7510.svg";
export { ForwardRef as ReactComponent };